/**
 * NetworkStatusBar Component
 *
 * Displays a banner when the device is offline or just reconnected.
 */

import PropTypes from "prop-types";
import { motion, AnimatePresence } from "framer-motion";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import Icon from "@mui/material/Icon";
import useNetworkStatus from "hooks/useNetworkStatus";

function NetworkStatusBar() {
  const { isOnline, wasOffline } = useNetworkStatus();

  return (
    <AnimatePresence>
      {!isOnline && (
        <motion.div
          initial={{ height: 0, opacity: 0 }}
          animate={{ height: "auto", opacity: 1 }}
          exit={{ height: 0, opacity: 0 }}
          transition={{ duration: 0.3 }}
        >
          <MDBox
            sx={{
              backgroundColor: "#FF9800",
              color: "white",
              py: 1,
              px: 2,
              textAlign: "center",
              position: "fixed",
              top: "env(safe-area-inset-top)",
              left: 0,
              right: 0,
              zIndex: 9999,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: 1,
            }}
          >
            <Icon fontSize="small">wifi_off</Icon>
            <MDTypography variant="caption" fontWeight="medium" color="white">
              You&apos;re offline. Some features may be unavailable.
            </MDTypography>
          </MDBox>
        </motion.div>
      )}

      {isOnline && wasOffline && (
        <motion.div
          initial={{ height: 0, opacity: 0 }}
          animate={{ height: "auto", opacity: 1 }}
          exit={{ height: 0, opacity: 0 }}
          transition={{ duration: 0.3 }}
        >
          <MDBox
            sx={{
              backgroundColor: "#4CAF50",
              color: "white",
              py: 1,
              px: 2,
              textAlign: "center",
              position: "fixed",
              top: "env(safe-area-inset-top)",
              left: 0,
              right: 0,
              zIndex: 9999,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: 1,
            }}
          >
            <Icon fontSize="small">wifi</Icon>
            <MDTypography variant="caption" fontWeight="medium" color="white">
              Back online!
            </MDTypography>
          </MDBox>
        </motion.div>
      )}
    </AnimatePresence>
  );
}

export default NetworkStatusBar;
